import { StyleSheet, TouchableOpacity, TouchableOpacityProps } from 'react-native';

import { useColor } from '@/hooks/useColor';

interface Props extends TouchableOpacityProps {}

const Card = (props: Props) => {
  const colors = useColor();
  return (
    <TouchableOpacity
      {...props}
      style={[styles.rectanglePressable, { backgroundColor: colors.background }, props.style]}
    />
  );
};

export default Card;

const styles = StyleSheet.create({
  rectanglePressable: {
    shadowColor: 'black',
    shadowOffset: {
      width: 0,
      height: 4
    },
    shadowRadius: 10,
    elevation: 4,
    shadowOpacity: 0.12,
    borderRadius: 10,
    alignItems: 'center'
  }
});
